import React from 'react';
import { useTranslation } from 'react-i18next';
import { trackEvent, AnalyticsEvents } from '../utils/analytics';

interface LanguageSwitcherProps {
  variant?: 'light' | 'dark';
}

const LanguageSwitcher: React.FC<LanguageSwitcherProps> = ({ variant = 'light' }) => {
  const { i18n } = useTranslation();

  const toggleLanguage = () => {
    const newLang = i18n.language === 'en' ? 'pl' : 'en';
    i18n.changeLanguage(newLang);
    trackEvent(AnalyticsEvents.LANGUAGE_CHANGE, { from: i18n.language, to: newLang });
  };

  const darkClasses =
    'flex items-center px-3 py-2 text-sm font-medium text-white/90 bg-white/[0.04] border border-white/[0.08] rounded-md hover:bg-white/[0.08] focus:outline-none focus:ring-2 focus:ring-offset-0 focus:ring-brand-primary transition-colors duration-200 backdrop-blur-xl';
  const lightClasses =
    'flex items-center px-3 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors duration-200';

  return (
    <button
      onClick={toggleLanguage}
      className={variant === 'dark' ? darkClasses : lightClasses}
      title={i18n.language === 'en' ? 'Switch to Polish' : 'Przełącz na angielski'}
    >
      <span className="mr-2 text-lg">
        {i18n.language === 'en' ? '🇺🇸' : '🇵🇱'}
      </span>
      <span className="text-xs font-semibold uppercase">
        {i18n.language === 'en' ? 'EN' : 'PL'}
      </span>
    </button>
  );
};

export default LanguageSwitcher; 